module.exports = __webpack_public_path__ + "bc54fcfb9ea2a255d83483b5f1dba959.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/help/platform.svg
// module id = 159
// module chunks = 0